module.exports = __webpack_public_path__ + "img/award-content-in.2632672f.png";